import React from 'react';
import Bugsnag from '../../utils/bugsnag';
import { jsx as _jsx } from "react/jsx-runtime";
var ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

var BugSnagErrorBoundary = function BugSnagErrorBoundary(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: children
  });
};

export default BugSnagErrorBoundary;